'use strict';

angular.module('clientDashboardApp').service('searchService', function ($q, $http) {


  var loadSearchResults = function (searchParams, searchResult) {
    if (searchResult.pendingResults) {
      return;
    }
    searchResult.pendingResults = true;

    var deferred = $q.defer();
    var params = angular.copy(searchParams);
    $http
      .get('/search/' + params.type, {
        params: params
      })
      .success(function (data, status, headers, config) {
        params.cursor = data.cursor;
        searchResult.results = searchResult.results.concat(data.results);
        searchResult.totalResults = data.totalResults;
        searchResult.params = params;
        deferred.resolve(searchResult);
        searchResult.pendingResults = false;
      })
      .error(function (data, status, headers, config) {
        deferred.reject({ data, status, headers });
        searchResult.pendingResults = false;
      });

    return deferred.promise;
  };

  SearchService.prototype.exportResults = function (searchParams) {
    var deferred = $q.defer();
    var params = angular.copy(searchParams);
    $http
      .get('/export/' + params.type, {
        params: params
      })
      .success(function (data, status, headers, config) {
        deferred.resolve(data);
      })
      .error(function (data, status, headers, config) {
        deferred.reject('Error occurred while getting search results!');
      });
    return deferred.promise;
  };

  function SearchResult() {
    this.results = [];
    this.params = {};
    this.pendingResults = false;
  }

  SearchResult.prototype.allReceivedResults = function () {
    return this.results;
  };

  SearchResult.prototype.sortResults = function (sortField, sortOrder) {
    delete this.params.cursor;
    this.params.sortField = sortField;
    this.params.sortOrder = sortOrder;

    //Clear existing results
    this.results = [];

    return loadSearchResults(this.params, this);
  };

  SearchResult.prototype.loadMoreResults = function (limit) {
    if (!this.hasMoreResults()) {
      return;
    }
    this.params.limit = limit;
    return loadSearchResults(this.params, this);
  };

  SearchResult.prototype.hasMoreResults = function () {
    return this.params.cursor > 0;
  };

  SearchResult.prototype.hasAnyResults = function () {
    return this.results.length > 0;
  };

  SearchResult.prototype.export = function () {
    var exportParams = angular.copy(this.params);
    var s = new SearchService();
    delete exportParams.limit;
    delete exportParams.cursor;
    return s.exportResults(exportParams);
  };

  function SearchService() {
  }

  SearchService.prototype.search = function (searchType, params) {
    params.type = searchType;
    return loadSearchResults(params, new SearchResult());
  };

  SearchService.prototype.searchScores = function (params) {
    params.type = 'scores';
    return loadSearchResults(params, new SearchResult());
  };

  SearchService.prototype.searchRankings = function (params) {
    params.type = 'rankings';
    return loadSearchResults(params, new SearchResult());
  };


  /**
   * creates a new SearchResult, merging specified configs with an optional previous SearchResult
   */
  SearchService.prototype.withExportConfig = function (type, theParams, reportParams, theResponse = new SearchResult()) {
    var newSearch = new SearchResult();
    newSearch.results = theResponse.results;
    newSearch.params = Object.assign({ type }, theResponse.params, theParams, reportParams);
    return newSearch;
  }

  SearchService.prototype.searchReviews = function (params) {
    params.type = 'reviews';
    return loadSearchResults(params, new SearchResult());
  };

  SearchService.prototype.searchListings = function (params) {
    params.type = 'listings';
    return loadSearchResults(params, new SearchResult());
  };
  SearchService.prototype.searchMentions = function (params) {
    params.type = 'mentions';
    return loadSearchResults(params, new SearchResult())
  };

  var searchService = new SearchService();
  searchService.SearchResult = SearchResult;
  return searchService;
});
